import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { supabase } from "./lib/supabase";
import Landing        from "./pages/Landing";
import Login          from "./pages/Login";
import Signup         from "./pages/Signup";
import Dashboard      from "./pages/Dashboard";
import BookingPage    from "./pages/BookingPage";
import StripeCallback  from "./pages/StripeCallback";
import SquareCallback  from "./pages/SquareCallback";
import AdminPanel     from "./pages/AdminPanel";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword  from "./pages/ResetPassword";
import Terms          from "./pages/Terms";
import Privacy        from "./pages/Privacy";
import InstallPrompt  from "./components/InstallPrompt";

export default function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => {
      setSession(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  if (loading) return <div style={{ background: "#080b10", minHeight: "100vh" }} />;

  return (
    <BrowserRouter>
      <InstallPrompt />
      <Routes>
        <Route path="/"           element={session ? <Navigate to="/dashboard" /> : <Landing />} />
        <Route path="/login"      element={session ? <Navigate to="/dashboard" /> : <Login />} />
        <Route path="/signup"     element={session ? <Navigate to="/dashboard" /> : <Signup />} />
        <Route path="/dashboard"  element={session ? <Dashboard session={session} /> : <Navigate to="/login" />} />
        <Route path="/admin"      element={session ? <AdminPanel session={session} /> : <Navigate to="/login" />} />
        <Route path="/book/:slug"      element={<BookingPage />} />
        <Route path="/stripe-callback" element={<StripeCallback />} />
        <Route path="/square-callback" element={<SquareCallback />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/terms"           element={<Terms />} />
        <Route path="/privacy"         element={<Privacy />} />
        <Route path="*"                element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
